// components/GlobalAlert.jsx
import useAlertStore from "@/store/use-alert-store";
import useAppStore from "@/store/use-app-store";
import { Alert, Box } from "@mui/material";
import { validArray } from "data/functions";
import { appear } from "data/styles/styleGlobals";
import React from "react";

export default function GlobalAlert() {
  const { alertArray } = useAlertStore();
  const { platform } = useAppStore();

  if (alertArray.length === 0) return;

  return (
    <Box
      sx={{
        background: "transparent",
        ...(platform === "iPhone" ? { bottom: 0 } : { top: 0 }),
        // bottom: isIphone ? 0 : undefined,
        display: "flex",
        flexDirection: platform === "iPhone" ? "column" : "column-reverse",
        justifyContent: "center",
        position: "absolute",
        width: "100%",
        zIndex: 2000,
      }}
    >
      {validArray(alertArray, "alertContext.render")
        .reverse()
        .slice(0, 3)
        .map((element, ind) => (
          <Alert
            action={element?.button ? element?.button : undefined}
            icon={false}
            key={element?.id}
            onClose={() => {
              useAlertStore.setState({
                alertArray: useAlertStore
                  .getState()
                  .alertArray.filter((v) => v.id !== element.id),
              });
            }}
            severity={element?.type}
            sx={{
              ".MuiAlert-action": {
                button: {
                  padding: "1px",
                  svg: {
                    height: "0.8em",
                    width: "0.8em",
                  },
                },
                marginLeft: "0",
                marginRight: "0",
                padding: "0px 6px",
              },
              ".MuiAlert-message": {
                marginLeft: "auto",
                marginRight: "auto",
                padding: "2px",
                textWrap: "balance",
              },
              alignItems: "center",
              animation: `${appear} .4s ease-in-out`,
              justifyContent: "center",
              // left: isMobile ? "0" : "256px",
              lineHeight: "1",
              marginBottom: "2px",
              padding: "0px",
              position: "sticky",
              textAlign: "center",
              top: "0",
              whiteSpace: "pre-line",
              width: "100%",
              zIndex: 2000,
            }}
            variant="filled"
          >
            {element?.text}
          </Alert>
        ))}
    </Box>
  );
}
